<template>
<div class="ActivityTempList bgc padding-20 box-shadow">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleAdd">新增活动模板</el-button>
        </div>
        <div class="search">
            <el-input v-model="param.eventname" placeholder="请输入活动名称" class="condition" clearable></el-input>
            <el-select v-model="param.resulttype" placeholder="凭证类型" class="condition" clearable>
                <el-option v-for="item in resulttypeList" :key="item.code" :label="item.name"
                           :value="item.code"></el-option>
            </el-select>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="活动名称" fixed class-name="left" min-width="296">
                <template slot-scope="scope">
                    <div class="nameBox">
                        <div class="iconBox">
                            <img :src="scope.row.coveratturlid?scope.row.coveratturlid:imgNoimg"
                                 :alt="scope.row.title">
                        </div>
                        <div class="rightBox">
                            <div class="title">
                                <div class="text">{{scope.row.eventname}}</div>
                            </div>
                            <div class="tip">
                                <span :class="resulttype(scope.row.resulttype)">{{scope.row.resulttypename}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="resulttypename" label="凭证类型" class-name="center" min-width="120px"></el-table-column>
            <el-table-column prop="logistypename" label="物流方式" class-name="center" min-width="120px">
                <template slot-scope="scope">{{scope.row.resulttype==5?scope.row.logistypename:'--'}}</template>
            </el-table-column>
            <el-table-column prop="viewcount" label="复制数" class-name="center"></el-table-column>
            <el-table-column label="操作" width="200px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                <span class="separator-btn">
                    <el-button @click="handleGoodsEdit(scope.row)" type="text" size="small">商品</el-button>
                </span>
                        <span class="separator-btn">
                    <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                </span>
                        <span class="separator-btn">
                    <el-button @click="handleShare(scope.row)" type="text" size="small">分享</el-button>
                </span>
                        <span class="separator-btn">
                    <el-dropdown>
                        <span class="el-dropdown-link">
                            <el-button type="text" size="small">更多</el-button>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleCopy(scope.row)">复制商家</el-dropdown-item>
                            <el-dropdown-item @click.native="handleDel(scope.row)">删除活动</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
    <invateLinkDialog ref="invateLinkDialog"></invateLinkDialog>
</div>
</template>

<script>
import InvateLinkDialog from 'views/brandBusiness/leaderMgt/myLeader/components/invateLinkDialog.vue'
import {getProviderEventListByPage, uploadProviderEventStatus} from 'api/brandBusiness'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {promiseUrlToQRCode} from 'common/js/tools'
import {brandBusiness} from 'api/enumCode'
export default {
    name: 'ActivityTempList',
    data() {
        return {
            imgNoimg: require('@/common/images/nationalDistributionMenu/img-noimg.png'),
            statusList: brandBusiness.eventstatus,
            resulttypeList: brandBusiness.resulttype,
            total: 0,
            tableData: [],
            power: [],
            param: {
                brandname: '',
                eventname: '',
                eventstatus: '',
            }
        }
    },
    mounted() {
        if (this.user.isprovider != '0') {
            this._getList()
        }
    },
    mounted() {
        if (this.user.isprovider != '0' && !this.isRefresh) {
            this.setPage({page: 1, pageSize: 10})
            this._getList()
        }
    },
    activated() {
        if (this.user.isprovider != '0' && this.isRefresh) {
            if (this.isRefresh === 2) {
                this.param = {
                    brandname: '',
                    eventname: '',
                    eventstatus: ''
                }
                this.setPage({page: 1, pageSize: 10})
            }
            this.$refs.page.handleSizeChange(this.page.page)
            this.setIsRefresh(0)
        }
    },
    methods: {
        handleQuery() {
            this.setParams(this._.cloneDeep(this.param))
            this.$refs.page.handleSizeChange(1)
        },
        handleGoodsEdit(row) {
            this.setIsRefresh(2)
            this.$router.push({name: 'SPActivityTempGoodsList', query: {eventid: row.eventid, hostroletype: 4}})
        },
        handleCopy(row) {
            this.$router.push({name: 'SPActvityTempBusiness', query: {eventid: row.eventid, title: row.eventname}})
            // this.$router.push({name: 'SPActivityTempEdit', query: {eventid: row.eventid, fromeventid: row.eventid, eventsource: 2}})
        },
        handleShare(row) {
            this.$refs.invateLinkDialog.openDialog(row.shareurl, '分享活动')
        },
        handleAdd() {
            this.$router.push({name: 'SPActivityTempEdit', query: {eventsource: 3, hostroletype: 4}})
        },
        handleEdit(row) {
            this.$router.push({name: 'SPActivityTempEdit', query: {eventid: row.eventid, eventsource: 3, hostroletype: 4}})
        },
        handleDel(row) {
            this.$confirm('确认删除该模板', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this._editStatus(row.eventid, 100, '删除成功')
            })
        },
        _editStatus(innerid, status, tip) {
            let obj = {
                eventid: innerid,
                status: status,
                eventtype: 10,
            }
            this.setLoading(true)
            uploadProviderEventStatus({
                data: obj,
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getProviderEventListByPage({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams',
            'setIsRefresh',
            'setPage'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        resulttype() {
            return function (value) {
                for (let i = 0; i < brandBusiness.resulttype.length; i++) {
                    if (value === brandBusiness.resulttype[i].code) {
                        return brandBusiness.resulttype[i].cls
                    }
                }
                return value
            }
        },
        eventstatus() {
            return function (value) {
                for (let i = 0; i < brandBusiness.eventstatus.length; i++) {
                    if (value === brandBusiness.eventstatus[i].code) {
                        return brandBusiness.eventstatus[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters([ 'page', 'user', 'permission', 'params', 'shop', 'isRefresh'])
    },
    components: {
        Page, InvateLinkDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.ActivityTempList {
    .filters {
        .el-input input {
            width: 180px;
        }
        .el-select .el-input input {
            width: 108px;
        }
    }
    .result-list {
        .el-table__row {
            height: 100px;
        }
        .el-table__body, .el-table__header {
            width: 100% !important;
        }
        .left {
            .cell {
                text-align: left;
                font-weight: 600;
                .nameBox {
                    display: flex;
                    .iconBox {
                        width: 106px;
                        height: 60px;
                        flex-shrink: 0;
                        flex-grow: 0;
                        margin-right: 10px;
                        img {
                            min-width: 106px;
                            height: 60px;
                        }
                    }
                    .rightBox {
                        min-width: 104px;
                        display: flex;
                        flex-direction: column;
                        .title {
                            height: 40px;
                            line-height: 20px;
                            overflow: hidden;
                            .text {
                                font-weight: 600;
                                float: right;
                                /* "margin-left"要等于".wrap::before"的宽度 */
                                margin-left: -10px;
                                width: 100%;
                                word-break: break-all;
                                text-align: left;
                                font-size: 14px;
                                // font-size: 0.48rem;
                            }
                            &::before {
                                float: left;
                                content: '';
                                width: 10px;
                                height: 100%;
                            }
                            &::after {
                                float: right;
                                content: "...";
                                /* 行高与".wrap"设置的一致即可 */
                                height: 40px;
                                line-height: 20px;
                                /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                                width: 37px;
                                margin-left: -37px;
                                /* 移动省略号位置 */
                                position: relative;
                                left: 101.9%;
                                bottom: 20px;
                                font-weight: 600;
                                padding-right: 1px;
                                background: #fff;
                                transition: all 0.5s;
                                text-align: left;
                            }
                        }
                        .tip {
                            font-size: 12px;
                            span + span {
                                margin-left: 10px;
                            }
                        }
                        .type {
                            text-align: left;
                        }
                        .type1 {
                            color: #67C23A;
                        }
                        .type2 {
                            color: #409EFF;
                        }
                        .type3 {
                            color: #E6A23C;
                        }
                        .type4 {
                            color: #F56C6C;
                        }
                    }
                }
            }
        }
        .right {
            .cell {
                text-align: right;
            }
        }
        .center {
            .cell {
                text-align: center;
                padding: 0;
                .nameBox {
                    display: flex;
                    .iconBox {
                        width: 106px;
                        height: 60px;
                        margin-right: 10px;
                        img {
                            min-width: 106px;
                            height: 60px;
                        }
                    }
                }
                .ing {
                    color: #67C23A;
                }
            }
        }
        .el-table__row:hover {
            .left {
                .cell {
                    .title {
                        &::after {
                            background: #F5F7FA;
                        }
                    }
                }
            }
        }
        .imageText {
            .imageText-summary {
                margin-left: 5px;
                .textBox {
                    width: 345px;
                    height: 40px;
                    line-height: 20px;
                    overflow: hidden;
                    .text {
                        float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        margin-left: -10px;
                        width: 345px;
                        word-break: break-all;
                        // font-size: 0.48rem;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 10px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 40px;
                        line-height: 20px;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 37px;
                        margin-left: -37px;
                        /* 移动省略号位置 */
                        position: relative;
                        left: 101.8%;
                        bottom: 20px;
                        font-weight: 600;
                        padding-right: 1px;
                        background: #fff;
                        transition: all 0.5s;
                    }
                    .recommon {
                        color: #fff;
                        background: #E6A23C;
                        display: inline-block;
                        width: 36px;
                        height: 16px;
                        line-height: 16px;
                        text-align: center;
                        margin-right: 5px;
                        font-size: 12px;
                    }
                }
                .price {
                    margin-left: 5px;
                    color: #F56C6C;
                }
            }
        }
        .el-table__row:hover {
            .textBox {
                &::after {
                    background: #F5F7FA;
                }
            }
        }
        img {
            min-width: 100px;
            max-width: 100px;
            height: 60px;
        }
        .icon {
            margin-left: 10px;
            width: 14px;
            height: 14px;
        }
    }
    .result-list .imageText .imageText-summary div:nth-child(1) {
        margin-bottom: 0;
    }
    .el-table {
        .title {
            .cell {
                padding: 0;
                margin-left: 5px;
            }
        }
        .center {
            .cell {
                text-align: center;
            }
        }
    }
}
</style>
